import {
  GraphQLObjectType,
  GraphQLNonNull,
  GraphQLID,
  GraphQLString,
  GraphQLBoolean,
  GraphQLList
} from 'graphql'

export const sensitiveDataMaskingSettingsType = new GraphQLObjectType({
  name: 'SensitiveDataMaskingSettings',
  fields: () => ({
    organizationID: {
      description: 'Organization ID for settings',
      type: new GraphQLNonNull(GraphQLID)
    },
    maskHttpBody: {
      description: 'Whether Mask HTTP Body setting is enabled',
      type: new GraphQLNonNull(GraphQLBoolean)
    },
    maskAttackVector: {
      description: 'Whether Mask Attack Vector setting is enabled',
      type: new GraphQLNonNull(GraphQLBoolean)
    }
  })
})

export const sensitiveDataPolicySummaryType = new GraphQLObjectType({
  name: 'SensitiveDataPolicySummary',
  fields: () => ({
    id: {
      description: 'The unique ID for a sensitive data policy',
      type: new GraphQLNonNull(GraphQLID)
    },
    groupID: {
      description: 'The unique ID for a sensitive data policy',
      type: new GraphQLNonNull(GraphQLID)
    },
    name: {
      description: 'The name for the sensitive data policy',
      type: new GraphQLNonNull(GraphQLString)
    },
    enabled: {
      description: 'Flag indicating if this policy is enabled or not',
      type: new GraphQLNonNull(GraphQLBoolean)
    },
    required: {
      description: 'Flag indicating if this policy is required or not',
      type: new GraphQLNonNull(GraphQLBoolean)
    },
    keywords: {
      description: 'The keywords for the policy',
      type: new GraphQLNonNull(new GraphQLList(GraphQLString))
    }
  })
})

const sensitiveDataApplicationType = new GraphQLObjectType({
  name: 'SensitiveDataApplication',
  fields: () => ({
    id: {
      description:
        'The unique ID for the application where this vulnerability was detected',
      type: new GraphQLNonNull(GraphQLID)
    },
    name: {
      description: 'The name of the application',
      type: new GraphQLNonNull(GraphQLString)
    }
  })
})

export const sensitiveDataRuleType = new GraphQLObjectType({
  name: 'SensitiveDataRule',
  fields: () => ({
    keywords: {
      description: 'The keywords for the rule',
      type: new GraphQLNonNull(new GraphQLList(GraphQLString))
    },
    applications: {
      description: 'The applications for the rule',
      type: new GraphQLNonNull(new GraphQLList(sensitiveDataApplicationType))
    }
  })
})

export const sensitiveDataPolicyType = new GraphQLObjectType({
  name: 'SensitiveDataPolicy',
  fields: () => ({
    id: {
      description: 'The unique ID for a sensitive data policy',
      type: new GraphQLNonNull(GraphQLID)
    },
    groupID: {
      description: 'The unique ID for a sensitive data policy',
      type: new GraphQLNonNull(GraphQLID)
    },
    name: {
      description: 'The name for the sensitive data policy',
      type: new GraphQLNonNull(GraphQLString)
    },
    enabled: {
      description: 'Flag indicating if this policy is enabled or not',
      type: new GraphQLNonNull(GraphQLBoolean)
    },
    required: {
      description: 'Flag indicating if this policy is required or not',
      type: new GraphQLNonNull(GraphQLBoolean)
    },
    isDefault: {
      description: 'Flag indicating if this policy is default or not',
      type: new GraphQLNonNull(GraphQLBoolean)
    },
    keywords: {
      description: 'The keywords for the policy',
      type: new GraphQLNonNull(new GraphQLList(GraphQLString))
    },
    customKeywords: {
      description: 'The custom keywords for the policy',
      type: new GraphQLNonNull(new GraphQLList(GraphQLString))
    }
  })
})
